<div
  class="chips-container"
  [class.hidden]="!hasConfirmedRegistration || invoices.length === 0"
>
  <mat-chip-listbox
    [(ngModel)]="selectedChips"
    [multiple]="true"
    (change)="onChipSelectionChange($event)"
  >
    <mat-chip-option value="company" color="warn">
      {{ labelService.getLabel("Aziende") }}
    </mat-chip-option>
    <mat-chip-option value="credit_note_sdi" color="primary">
      {{ labelService.getLabel("Note di Credito SDI") }}
    </mat-chip-option>
    <mat-chip-option value="year" color="primary">
      {{ currentYear }}
    </mat-chip-option>
    <mat-chip-option
      value="date_range"
      [selected]="showDatePicker"
      (click)="toggleDatePicker()"
    >
      {{ labelService.getLabel("Intervallo Date") }}
    </mat-chip-option>
  </mat-chip-listbox>

  <!-- Add this after mat-chip-listbox -->
  @if (showDatePicker) {
    <div class="date-range-container">
      <mat-form-field appearance="fill">
        <mat-label>{{ labelService.getLabel("Date inizio e fine") }}</mat-label>
        <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker">
          <input
            matStartDate
            formControlName="start"
            placeholder="Start date"
          />
          <input matEndDate formControlName="end" placeholder="End date" />
        </mat-date-range-input>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <button
        mat-raised-button
        class="white-button"
        [disabled]="
          !dateRange.get('start')?.value || !dateRange.get('end')?.value
        "
        (click)="onDateRangeChange()"
      >
        {{ labelService.getLabel("Filtra") }}
      </button>
    </div>
  }
</div>

@if (selectedInvoices.size > 0) {
  <div class="selection-summary">
    @if (selectedSDIInvoices.length > 0) {
      <div class="summary-row">
        <div class="summary-info">
          <span
            >{{ labelService.getLabel("Fatture SDI Selezionate") }}:
            {{ selectedSDIInvoices.length }}</span
          >
          <!-- <span *ngIf="!canSendInvoices('sdi')" class="warning">
            {{ labelService.getLabel('Fatture non inviabili') }}:
            {{ getNotSendableInvoices('sdi') }}
          </span>
          <span *ngIf="!canDeleteInvoices('sdi')" class="warning">
            {{ labelService.getLabel('Fatture non eliminabili') }}:
            {{ getNotDeletableInvoices('sdi') }}
          </span> -->
        </div>
        <div class="summary-actions">
          <!-- <button
          mat-raised-button
          color="primary"
          [disabled]="!canSendInvoices('sdi')"
          (click)="onSendSelected('sdi')"
          >
          {{ labelService.getLabel('Invia') }}
        </button>
        <button
          mat-raised-button
          color="warn"
          [disabled]="!canDeleteInvoices('sdi')"
          (click)="onDeleteSelected('sdi')"
          >
          {{ labelService.getLabel('Elimina') }}
        </button> -->
        </div>
      </div>
    }
  </div>
}

@if (invoices.length > 0 && !isLoadingInvoices) {
  <div class="table-container">
    <table
      mat-table
      [dataSource]="filteredInvoices"
      class="invoice-table"
      matSort
      (matSortChange)="onSort($event)"
    >
      <!-- Number Column -->
      <ng-container matColumnDef="number">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="progressivo_numero"
        >
          <div class="header-content">
            <span>{{ labelService.getLabel("number") }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let invoice">
          {{ invoice.progressivo_numero }}
        </td>
      </ng-container>
      <!-- Year Column -->
      <ng-container matColumnDef="year">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="progressivo_anno"
        >
          <div class="header-content">
            <span>{{ labelService.getLabel("year") }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let invoice">
          {{ invoice.progressivo_anno }}
        </td>
      </ng-container>
      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          {{ labelService.getLabel("status") }}
        </th>
        <td mat-cell *matCellDef="let invoice">{{ invoice.stato }}</td>
      </ng-container>
      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="data">
          <div class="header-content">
            <span>{{ labelService.getLabel("date") }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let invoice">{{ invoice.data }}</td>
      </ng-container>
      <!-- Type Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>
          {{ labelService.getLabel("type") }}
        </th>
        <td mat-cell *matCellDef="let invoice">{{ invoice.tipo }}</td>
      </ng-container>
      <!-- Client Column -->
      <ng-container matColumnDef="sender">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-content">
            @if (!showClientSearch) {
              <span>{{ labelService.getLabel("Mittente") }}</span>
            }
            <div class="search-container" [class.active]="showClientSearch">
              <mat-icon class="search-icon" (click)="toggleClientSearch()">
                {{ showClientSearch ? "close" : "search" }}
              </mat-icon>
              @if (showClientSearch) {
                <div class="search-input-container">
                  <input
                    type="text"
                    class="search-input"
                    [value]="clientSearchValue"
                    (input)="onClientSearchChange($event)"
                    placeholder="Cerca mittente..."
                    #searchInput
                  />
                  @if (clientSearchValue) {
                    <mat-icon class="clear-icon" (click)="clearSearch()">
                      clear
                    </mat-icon>
                  }
                </div>
              }
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let invoice">{{ invoice.mittente }}</td>
      </ng-container>
      <!-- Total Column -->
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef>
          {{ labelService.getLabel("total") }}
        </th>
        <td mat-cell *matCellDef="let invoice">{{ invoice.totale }}</td>
      </ng-container>
      <!-- Pagata Column -->
      <ng-container matColumnDef="pagata">
        <th mat-header-cell *matHeaderCellDef>
          {{ labelService.getLabel("Pagata") }}
        </th>
        <td mat-cell *matCellDef="let invoice">
          <mat-checkbox
            [checked]="invoice.pagata"
            (change)="onPagataChange(invoice, $event)"
          >
          </mat-checkbox>
        </td>
      </ng-container>
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let invoice">
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            class="action-button"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="showNotifications(invoice)">
              <mat-icon>notifications</mat-icon>
              <span>{{ labelService.getLabel("Storico Notifiche") }}</span>
            </button>
            <button mat-menu-item (click)="previewInvoice(invoice)">
              <mat-icon>preview</mat-icon>
              <span>{{ labelService.getLabel("Anteprima") }}</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <!-- Select Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="masterToggle()"
            [checked]="isAllSelected()"
            [indeterminate]="isIndeterminate()"
            [aria-label]="'Select all invoices'"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="onRowSelection(row)"
            [checked]="isSelected(row)"
            [aria-label]="'Select invoice'"
          >
          </mat-checkbox>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
}

@if (isLoadingInvoices) {
  <div class="loading-container">
    <app-loader [size]="'big'"></app-loader>
  </div>
}

@if (invoices.length === 0 && !isLoadingInvoices) {
  <div class="no-data-container">
    <div class="empty-state-card">
      <img
        src="assets/imgs/undraw/undraw_empty.svg"
        alt="Nessun Documento"
        [class.hidden]="!hasConfirmedRegistration"
      />
      @if (!hasConfirmedRegistration) {
        <div class="empty-state-content">
          <h3>{{ labelService.getLabel("Configurazione Necessaria") }}</h3>
          <p class="setup-message">
            Per ricevere le fatture dai tuoi fornitori, è necessario popolare la
            propria partita IVA nella pagina
            <a routerLink="/fatture/dati-fatturazione">I Miei Dati</a>.
            Successivamente, è necessario registrare il Codice Destinatario
            fornito da PsicoGenius sul sito dell'Agenzia delle Entrate
          </p>
          <div class="confirmation-checkbox">
            <mat-checkbox
              (change)="onRegistrationConfirmed($event)"
              color="primary"
            >
              Ho completato la registrazione del Codice Destinatario
            </mat-checkbox>
          </div>
          <button mat-raised-button color="primary" (click)="openFAQ()">
            <mat-icon>help_outline</mat-icon>
            Consulta la FAQ
          </button>
        </div>
      }
      @if (hasConfirmedRegistration) {
        <div class="empty-state-content">
          <h3>{{ labelService.getLabel("Nessuna Fattura") }}</h3>
          <p>Non sono presenti fatture da visualizzare</p>
        </div>
      }
    </div>
  </div>
}
